import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { GroupTag } from '@sleipai/sleip-models';

export const groupTagsFeatureKey = 'groupTags';

export interface GroupTagState extends EntityState<GroupTag> {}

export const groupTagAdapter: EntityAdapter<GroupTag> = createEntityAdapter<GroupTag>();

export const {
  selectIds: selectGroupTagIdsAdapter,
  selectEntities: selectGroupTagEntitiesAdapter,
  selectAll: selectAllGroupTagsAdapter,
  selectTotal: selectGroupTagsTotalAdapter,
} = groupTagAdapter.getSelectors();